import {
  FETCH_START,
  FETCH_END,
  DISTRIBUTOR_CONTRACT_DATA,
  MANAGE_CLAIMS_DATA,
  MANAGE_CLAIMS_PROFILE,
  MANAGE_CLAIMS_NEXT_STATUS,
  MANAGE_CLAIMS_USER_TABS,
} from '../../actions/DistributorChargeback/ActionTypes';

const initialState = {
  loading: false,
  contractData: {},
  // Manage Claims: claim lines (claims-data / process-claims), the claims profile response and the
  // next statuses per workflow and current status ({ [workflow]: { [status]: { options, details, loading?, failed? } } }).
  manageClaimsData: [],
  manageClaimsProfile: null,
  manageClaimsNextStatuses: {},
};

const DistributorChargebackReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISTRIBUTOR_CONTRACT_DATA:
      return { ...state, contractData: action.data };
    case MANAGE_CLAIMS_DATA:
      return { ...state, manageClaimsData: action.data };
    case MANAGE_CLAIMS_PROFILE:
      return { ...state, manageClaimsProfile: action.data };
    // A fresh user-tabs list replaces the profile's user_tabs.
    case MANAGE_CLAIMS_USER_TABS:
      return state.manageClaimsProfile
        ? { ...state, manageClaimsProfile: { ...state.manageClaimsProfile, user_tabs: action.data } }
        : state;
    case MANAGE_CLAIMS_NEXT_STATUS: {
      const { workflowName, status, value } = action.data;
      const byStatus = state.manageClaimsNextStatuses[workflowName] || {};
      return {
        ...state,
        manageClaimsNextStatuses: { ...state.manageClaimsNextStatuses, [workflowName]: { ...byStatus, [status]: value } },
      };
    }
    case FETCH_START:
      return { ...state, loading: true };
    case FETCH_END:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default DistributorChargebackReducer;
